import { Group } from "../../Group/index";
import { Main } from "../../Main/index";
import { Container } from "../../Container/index";
import setWindowData from "../set-window-data";
import WINDOW from "../window";
import initAnimate from "../../Main/listeners/utils/init-animate";

/**
 * Sets up a MutationObserver to perform actions before mutations occur in the DOM.
 *
 * @function
 * @name beforeMutation
 *
 */
const beforeMutation = (manual = false) => {
  setWindowData();

  /**
   * Callback function to be executed when a mutation is observed.
   * @function
   * @param {MutationRecord[]} entries - An array of mutation records.
   */
  const callback = (entries) => {
    const mains = {
      added: new Set(),
      removed: new Set(),
    };

    const groups = {
      added: new Set(),
      removed: new Set(),
    };

    const containers = {
      added: new Set(),
      removed: new Set(),
    };

    for (const entry of entries) {
      const added = /** @type {Array<TorusElement>} */ (
        Array.from(entry.addedNodes)
      );

      const removed = /** @type {Array<HTMLElement>} */ (
        Array.from(entry.removedNodes)
      );

      for (const node of added) {
        if (!node.dataset) {
          continue;
        }

        if (node.hasAttribute("data-tor")) {
          node.Torus = node.Torus || {};
          mains.added.add(node);
        }
        if (node.hasAttribute("data-tor-group")) {
          node.Torus = node.Torus || {};
          groups.added.add(node);
        }
        if (node.hasAttribute("data-tor-container")) {
          node.Torus = node.Torus || {};
          containers.added.add(node);
        }
      }

      for (const node of removed) {
        if (!node.dataset) {
          continue;
        }

        if (node.hasAttribute("data-tor")) {
          mains.removed.add(node);
        }
        if (node.hasAttribute("data-tor-group")) {
          groups.removed.add(node);
        }
        if (node?.hasAttribute("data-tor-container")) {
          containers.removed.add(node);
        }
      }
    }

    if (groups.added.size) {
      Group.init(groups.added);
    }
    if (mains.added.size) {
      Main.init(mains.added);

      // TODO: investigate how to init animations on frameworks like Svelte
      if (WINDOW.get("async-initialized")) {
        initAnimate(...mains.added);
      }
    }
    if (containers.added.size) {
      Container.init(containers.added);
    }

    if (groups.removed.size) {
      Group.destroy(groups.removed);
    }
    if (mains.removed.size) {
      Main.destroy(mains.removed);
    }
    if (containers.removed.size) {
      Container.destroy(containers.removed);
    }
  };

  /** Get global `observers` map */
  const observers = /** @type {WindowObserverProps} */ (
    WINDOW.get("observers")
  );

  /** Set new `MutationObserver` to the map */
  observers.set("mutation", new MutationObserver(callback));

  /** Set type */
  const mutation = /** @type {MutationObserver} */ (observers.get("mutation"));

  /** Initialize the observer with options */
  mutation.observe(document, {
    childList: true,
    subtree: true,
    attributeFilter: ["data-tor", "data-tor-group", "data-tor-container"],
  });
};

export default beforeMutation;
